module.exports = __webpack_public_path__ + "assets/qianzheng.491ae0bb.svg";